import messages from '~/constants/localizations/teamStats';
import { Schema } from './index.d';

export const SOCCER_PREGAME: Schema[] = [
  {
    key: 'shots_per_game',
    meta_key: 'shots_per_game_rank',
    label: 'Shots',
  },
  {
    key: 'shots_on_target_per_game',
    meta_key: 'shots_on_target_per_game_rank',
    label: 'Shots on Target',
  },
  {
    key: 'goals_per_game',
    meta_key: 'goals_per_game_rank',
    label: 'Goals',
  },
  {
    key: 'passes_per_game',
    meta_key: 'passes_per_game_rank',
    label: 'Passes',
  },
  {
    key: 'completed_passes_per_game',
    meta_key: 'completed_passes_per_game_rank',
    label: 'Completed Passes',
  },
  {
    key: 'crosses_per_game',
    meta_key: 'crosses_per_game_rank',
    label: 'Crosses',
  },
  {
    key: 'long_balls_per_game',
    meta_key: 'long_balls_per_game_rank',
    label: 'Long Balls',
  },
  {
    key: 'tackles_attempted_per_game',
    meta_key: 'tackles_attempted_per_game_rank',
    label: 'Tackles Attempted',
  },
  {
    key: 'tackles_won_per_game',
    meta_key: 'tackles_won_per_game_rank',
    label: 'Tackles Succeeded',
  },
  {
    key: 'fouls_per_game',
    meta_key: 'fouls_per_game_rank',
    label: 'Fouls',
  },
];

export const SOCCER: Schema[] = [
  {
    key: 'formation',
    label: 'Formation',
    localized_label: messages.soccer.formation,
  },
  {
    key: 'ball_possession',
    label: 'Possession',
    localized_label: messages.soccer.ball_possession,
  },
  {
    key: 'shots_on_goal',
    label: 'Shots (on goal)',
    localized_label: messages.soccer.shots_on_goal,
  },
  {
    key: 'corner_kicks',
    label: 'Corner Kicks',
    localized_label: messages.soccer.corner_kicks,
  },
  {
    key: 'crosses',
    label: 'Crosses',
    localized_label: messages.soccer.crosses,
  },
  {
    key: 'fouls',
    label: 'Fouls',
    localized_label: messages.soccer.fouls,
  },
  {
    key: 'yellow_cards',
    label: 'Yellow Cards',
    localized_label: messages.soccer.yellow_cards,
  },
  {
    key: 'red_cards',
    label: 'Red Cards',
    localized_label: messages.soccer.red_cards,
  },
  {
    key: 'offsides',
    label: 'Offsides',
    localized_label: messages.soccer.offsides,
  },
  {
    key: 'assists',
    label: 'Assists',
    localized_label: messages.soccer.assists,
  },
];
